import { createContext, useEffect, useRef, useState, useContext, useCallback } from 'react';
import RecipientsItem from './pane-left-recipients-item-template';
import { getAccounts } from '../common/api-requests';
import './pane-left-recipients.scss';
import { TextBox } from 'devextreme-react/text-box';
import { ErrorContext } from '../context/error-context';
import { AccountContext } from '../context/account-context'
import { RecipientsContext } from '../context/recipients-context';

export default function ListRecipients() {

    const [account, setAccount] = useContext(AccountContext);
    const [recipients, setRecipients] = useContext(RecipientsContext);
    const [error, setError] = useContext(ErrorContext);
    
    const [stateAccount, setStateAccount] = useState(account);
    const [stateRecipients, setStateRecipients] = useState([]);
    const [timeoutId, setTimeoutId] = useState(null);
    const [searchValue, setSearchValue] = useState(null);


    useEffect(() => {

        let result = [];

        if (!recipients || !recipients.length)
            return;

        result = [...recipients];

        if (searchValue) {
            setStateRecipients(recipients.filter(item => item.name.toLowerCase().includes(searchValue.toLowerCase())));
        }
        else{
            setStateRecipients(recipients);
        }
       
    }, [recipients, searchValue]);


    const handleTextBoxOnValueChanged = (e) => {

        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        const newTimeoutId = setTimeout(() => {

            setSearchValue(e.value.toLowerCase()); 

        }, 1000);

        setTimeoutId(newTimeoutId);
    };


    const handleRead = (recipientID, readIDs) => {

        let index = recipients.findIndex(a => a.id == recipientID);

        if (index == -1)
            return;

        if (!recipients[index].newMessages)
            return;

        if (!recipients[index].newMessages.some(obj1 => readIDs.some(obj2 => obj2 === obj1)))
            return;

        setRecipients(prevRecipients => {
            let updRecipients = [...prevRecipients];

            let newMessages = updRecipients[index].newMessages.filter(item1 => !readIDs.some(item2 => item1 === item2));

            updRecipients[index] = { ...updRecipients[index], newMessages: newMessages };

            return updRecipients;
        });
    }


    return (

        <div className="list-recipients-container">
            <div className='list-recipients-header'>
                <TextBox className="list-recipients-search"
                    placeholder="Шукати..."
                    mode="search"
                    valueChangeEvent="keyup"
                    onValueChanged={handleTextBoxOnValueChanged}
                />
            </div>

            <div className='list-recipients'>
                {stateRecipients.map((recipient, index) => {
                    return (

                        <RecipientsItem key={index} recipient={recipient} handleRead={handleRead}></RecipientsItem>
                    )
                })}
            </div>
        </div>
    );
}



